import Col from 'react-bootstrap/Col'
import React, {useEffect} from 'react'
import {useBox} from "../../../hooks/useBox";

interface BoxInterface {
    boxContentBg?: string,
    boxContentBorder?: boolean,
    boxContentBorderColor?: string,
    boxContentClassNames?: string,
    boxContentTextColor?: string,
    boxContentRounded?: string,
    boxContentPadding?: string,
    boxClassNames?: string,
    boxCol?: string,
    boxLg?: number,
    boxHd?: string,
    boxMd?: number,
    boxName: string,
    boxSm?: number,
    boxXl?: number,
    boxXs?: number,
    boxXxl?: string,
    content: Object,
    header?: boolean,
    headerBg?: string,
    headerBorder?: boolean,
    headerBorderColor?: string,
    headerClassNames?: string,
    headerContent?: Object,
    headerPadding?: string,
    headerRounded?: string,
    headerTextColor?: string,
    stickyHeader?: boolean,
    targetStickyClasses?: string,
    style?: Object,
    onClick?: Function,
}

const Box = ({
 boxXs,
 boxSm,
 boxMd,
 boxLg,
 boxXl,
 boxCol,
 boxName,
 boxXxl,
 boxHd,
 boxClassNames,
 boxContentClassNames,
 header,
 headerContent,
 stickyHeader,
 targetStickyClasses,
 content,
 onClick,
 style,
...useBoxProps}: BoxInterface) => {

  const {
    headerBoxClassNames,
    contentBoxClassNames
  } = useBox(useBoxProps, stickyHeader)

  const handleSticky = () => {
    const stickyHeaderElt = document.querySelector('[data-sticky-header]')

    if (stickyHeaderElt) {
      const stickyWithHeader = Array.from(
        document.getElementsByClassName(targetStickyClasses)
      ).sort(
        (sticky1, sticky2) => {
          const {top: top1} = sticky1.getBoundingClientRect()
          const {top: top2} = sticky2.getBoundingClientRect()

          return (top1 < top2) ? -1 : 1
        }
      )

      stickyWithHeader.forEach((elt) => {
          stickyHeaderElt.append(elt)
          stickyHeaderElt.style.color = 'black'
          stickyHeaderElt.style.padding = '0'
      })
    }
  }

  useEffect(() => {
    if (stickyHeader) {
      handleSticky()
    }
  }, [stickyHeader]);

  return (
    <Col
      xs={boxXs || 12}
      sm={boxSm || ''}
      md={boxMd || ''}
      lg={boxLg || ''}
      xl={boxXl || ''}
      className={`box ${boxName} ${boxXxl ? `col-xxl-${boxXxl} ` : ''}${
        boxHd ? `col-hd-${boxHd} ` : ''
      }${boxCol ? `col-${boxCol} ` : ''}${
        boxClassNames ? `${boxClassNames} ` : 'mb-3 '
      }d-inline-block`}>
      {header && (
        <div
          className={`header ${headerBoxClassNames}`} data-sticky-header={''}>
          {headerContent}
        </div>
      )}
      <div
        onClick={onClick}
        style={style}
        className={`content ${contentBoxClassNames} w-100 ${boxContentClassNames}`}>
        {content}
      </div>
    </Col>
  )
}

export default Box
